<script lang="ts">
  // Renders a component loaded via dynamic import(), so its code + deps land in a
  // separate chunk fetched on first use — keeping them out of the initial bundle.
  import { untrack } from 'svelte';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let { load, props = {} }: { load: () => Promise<any>; props?: Record<string, unknown> } = $props();
  // Kick off the import once, on mount (load is stable per instance).
  const promise = untrack(() => load());
</script>

{#await promise then mod}
  {@const C = mod.default}
  <C {...props} />
{:catch}
  <div class="lazy-err faint">Couldn’t load this section. Please try again.</div>
{/await}

<style>
  .lazy-err { padding: var(--space-6, 24px); text-align: center; font-size: var(--fs-sm, 14px); }
</style>
